import { MenuProps } from "antd"
import { options } from "../types/campaignActions"

export const MENU_PROPS_ITEMS: MenuProps["items"] = [
  {
    label: options.PAUSE,
    key: options.PAUSE,
  },
  {
    label: options.ENABLE,
    key: options.ENABLE,
  },
  {
    label: options.UNMANAGE,
    key: options.UNMANAGE,
  },
  {
    label: options.APPLY_BEST_CPC,
    key: options.APPLY_BEST_CPC,
  },
  {
    label: options.ADD_TO_PROJECT,
    key: options.ADD_TO_PROJECT,
  },
]
